import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { Alignment, TableColumnProperties, Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { ExcelExport } from './excel.types';
import { } from 'lodash';
import { AlertService } from '@common/components/alert/alert.service';

@Injectable({
  providedIn: 'root',
})
export class ExcelService {

  constructor(
    private _alertService: AlertService
  ) { }

  cvsExport(data: any[], columns: any[]) {
    //Sort by Key & remove invalid columns
    let sortedArray = [];
    if (data !== null && columns !== null) {
      data.forEach(x => {
        let row = {};
        columns.map(y => {
          row[y] = x[y];
        });
        sortedArray.push(row);
      });
      return sortedArray;
    }
    return [];
  }

  cvsExport2(data: any[], columns: any[]) {
    //Sort by Key & remove invalid columns
    let sortedArray = [];
    if (data && columns) {
      data.forEach(x => {
        let row = [];
        columns.map((y, index) => {
          row[index] = x[y];
        });
        sortedArray.push(row);
      });
      return sortedArray;
    }
    return [[]];
  }

  cvsExport3(data: any[], columns: any[]) {
    //Sort by Key & remove invalid columns
    let sortedArray = [];
    if (data && columns) {
      data.forEach(x => {
        let row = [];
        columns.map((y, index) => {
          row[index] = this.resolve(y, x);
        });
        sortedArray.push(row);
      });
      return sortedArray;
    }
    return [[]];
  }

  cvsExport4(data: any[], columns: any[]) {
    //Sort by Key & remove invalid columns
    let sortedArray = [];
    if (data && columns) {
      data.forEach(x => {
        let row = [];
        columns.map((y, index) => {
          row[index] = this.resolve(y.colCode, x);
        });
        sortedArray.push(row);
      });
      return sortedArray;
    }
    return [[]];
  }

  resolve(path, obj) {
    return path.split('.').reduce(function (prev, curr) {
      return prev ? prev[curr] : null
    }, obj || self)
  }

  getDDMMYYYY_HHMMSS(dateinput: Date) {
    if (dateinput) {
      let mm = (dateinput.getMonth() + 1).toString(); // getMonth() is zero-based
      let dd = dateinput.getDate().toString();
      let yy = dateinput.getFullYear().toString();
      let h = dateinput.getHours().toString();
      let m = dateinput.getMinutes().toString();
      let s = dateinput.getSeconds().toString();

      return [dd.length === 2 ? '' : '0', dd, mm.length === 2 ? '' : '0', mm, yy].join('')
        .concat('_').concat(
          [h.length === 2 ? '' : '0', h, m.length === 2 ? '' : '0', m, s.length === 2 ? '' : '0', s].join("")); // padding
    }
    return '';
  }

  public static getDDMMYYYY(dateinput: Date, separator = '') {
    if (dateinput) {
      let mm = (dateinput.getMonth() + 1).toString(); // getMonth() is zero-based
      let dd = dateinput.getDate().toString();
      let yy = dateinput.getFullYear().toString();

      return [(dd.length === 2 ? '' : '0') + dd, (mm.length === 2 ? '' : '0') + mm, yy].join(separator); // padding
    }
    return '';
  }

  exportTitle(identifer: string) {
    return identifer.concat("_").concat(this.getDDMMYYYY_HHMMSS(new Date));
  }

  convertToDate(dateString: String) {
    //  Convert a "dd-MM-yyyy" string into a Date object
    let dateParts = dateString.split("-");
    let dat = new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);
    return dat;
  }

  exportAsExcel(data: ExcelExport, title) {
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Sheet1');

    worksheet.addTable({
      name: 'MyTable1',
      ref: 'A1',
      headerRow: true,
      totalsRow: false,
      style: {
        showRowStripes: false,
      },
      columns: data.mapping.map<TableColumnProperties>(x => ({ name: x.colName, filterButton: true })),
      rows: this.cvsExport4([].concat.apply([], data.data), data.mapping),
    });

    //Auto-Width
    worksheet.columns.forEach(function (column, i) {
      let maxLength = 10;
      column["eachCell"]({ includeEmpty: true }, function (cell) {
        let columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = maxLength < 10 ? 12 : maxLength > 50 ? 55 : maxLength + 5;
    });

    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      this.downloadFile(blob, this.exportTitle(title));
    })
  }
  async exportBrandLabelsWithImages(data: any[], mapping: any[], title: string) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Brand Labels');

    // 1. Add Headers
    const headerRow = worksheet.addRow(mapping.map(m => m.colName));
    headerRow.font = { bold: true };

    // 2. Add Data Rows
    for (const [rowIndex, item] of data.entries()) {
      const rowData = mapping.map(m => {
        // Try to resolve (handles 'brand.code')
        let val = this.resolve(m.colCode, item);

        // Fallback: If null, check if the colCode exists as a flat key (handles 'brandCode')
        if (val === null || val === undefined) {
          var colCode = m.colCode.includes('brand') ? 'brandCode' : m.colCode;
          val = item[colCode]; // Remove dot for fallback
        }

        return val || '';
      });

      const row = worksheet.addRow(rowData);

      // Set row height to fit the logo (approx 100-120 pixels)
      row.height = 90;

      // 3. Handle Image via Presigned URL
      // We look for the image URL in the item data
      const imageUrl = item.imagePresignedUrl || item.imageUrl;

      if (imageUrl && imageUrl.startsWith('http')) {
        // Find which column index is the 'Image' column in the mapping
        const imgColIndex = mapping.findIndex(m => m.colCode === 'imagePresignedUrl' || m.colCode === 'imageUrl');

        if (imgColIndex !== -1) {
          try {
            // Fetch image from S3 Presigned URL
            const response = await fetch(imageUrl);
            if (!response.ok) throw new Error('Network response was not ok');

            const arrayBuffer = await response.arrayBuffer();

            // Detect extension from URL or default to png
            const extension = imageUrl.split('.').pop().split('?')[0].toLowerCase() || 'png';

            const imageId = workbook.addImage({
              buffer: arrayBuffer,
              extension: extension as any,
            });

            // Insert image into the cell
            worksheet.addImage(imageId, {
              tl: { col: imgColIndex, row: rowIndex + 1 }, // row 0 is headers, so index + 1
              ext: { width: 110, height: 110 },
              editAs: 'oneCell'
            });

            // Clear the text URL from the cell so it doesn't overlap the image
            row.getCell(imgColIndex + 1).value = "";
          } catch (error) {
            console.error("Excel Image Export Error:", error);
            row.getCell(imgColIndex + 1).value = "Image Load Failed";
          }
        }
      }
    }

    // 4. Formatting
    worksheet.columns.forEach((column) => {
      column.width = 25;
      column.alignment = { vertical: 'middle', horizontal: 'center' };
    });

    // 5. Finalize and Download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    this.downloadFile(blob, this.exportTitle(title));
  }
  downloadFile(blob, title: string) {
    fs.saveAs(blob, title);
    this._alertService.success("Download Completed!", '', { autoClose: true });
  }
}